export function formatJsonAsKeyValueString(jsonString: string|null): string {
  if (jsonString === null) {
    return '';
  }

  try {
    const parsed = JSON.parse(jsonString);

    return Object.entries(parsed)
        .map(([key, value]) => `${key} = ${value}`)
        .join('\n');
  } catch (error) {
    console.error('Invalid JSON string:', error);

    return jsonString;
  }
}

export function formatJsonAsArray(jsonString: string|null): { key: string; value: any }[] {
  if (jsonString === null) {
    return [];
  }

  try {
    const parsed = JSON.parse(jsonString);

    return Object.entries(parsed).map(([key, value]) => ({ key, value }));
  } catch (error) {
    console.error('Invalid JSON string:', error);

    return [];
  }
}
